// Recovered compiled webpack factory 35043. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { x: () => o });
  var n = i(33182),
    s = i(40479),
    r = i(76066);
  function o(t, e, i) {
    let o = (0, r.x)(t, e, i);
    for (let i in t)
      ((0, n.S)(t[i]) || (0, n.S)(e[i])) &&
        (o[-1 !== s.U.indexOf(i) ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i] = t[i]);
    return o;
  }
}
